/**
 * Utility functions for managing loading states
 */

/**
 * Safely show loading spinner
 * @param {Vue} vm - Vue instance
 */
export function safeShowLoading (vm) {
  if (vm && typeof vm.showLoading === 'function') {
    vm.showLoading()
  }
}

/**
 * Safely hide loading spinner
 * @param {Vue} vm - Vue instance
 */
export function safeHideLoading (vm) {
  if (vm && typeof vm.hideLoading === 'function') {
    vm.hideLoading()
  }
}

/**
 * Force hide loading spinner (direct DOM manipulation)
 */
export function forceHideLoading () {
  const spinner = document.getElementById('spinner')
  if (spinner) {
    spinner.style.display = 'none'
  }
}

/**
 * Check if loading spinner is currently visible
 * @returns {boolean}
 */
export function isLoadingVisible () {
  const spinner = document.getElementById('spinner')
  return spinner && spinner.style.display !== 'none'
}

/**
 * Clear any lingering loading state
 * This should be called when navigating away from pages
 */
export function clearLoadingState () {
  forceHideLoading()
}

/**
 * Wrapper for API calls that ensures loading state is properly managed
 * @param {Vue} vm - Vue instance
 * @param {Function} apiCall - The API call function
 * @param {boolean} showLoading - Whether to show loading spinner
 * @returns {Promise}
 */
export async function withLoadingState (vm, apiCall, showLoading = true) {
  try {
    if (showLoading) {
      safeShowLoading(vm)
    }

    return await apiCall()
    // eslint-disable-next-line no-useless-catch
  } catch (error) {
    throw error
  } finally {
    if (showLoading) {
      safeHideLoading(vm)
    }
  }
}
